export default __webpack_public_path__ + "static/media/c002-PPII-16.d02077d7.svg";